import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Each node's place in Godot's tree order, the pre-order walk in which nodes enter the tree. A
 * sub-scene that loads late still takes its place, which React's mount order cannot give.
 */
import { createContext, useContext } from 'react';
const SCENE_ROOT = Object.freeze([]);
const TreeOrderContext = createContext(SCENE_ROOT);
TreeOrderContext.displayName = 'TreeOrderContext';
export function TreeOrderProvider({ order, children }) {
    return _jsx(TreeOrderContext.Provider, { value: order, children: children });
}
/** The enclosing node's place in tree order. Outside the dispatcher, every node ties at the root. */
export function useTreeOrder() {
    return useContext(TreeOrderContext);
}
/** The orders of `count` children of the node at `parent`. */
export function childOrders(parent, count) {
    return Array.from({ length: count }, (_, i) => [...parent, i]);
}
/** Negative when `a` enters the tree before `b`, zero for one place. An ancestor comes first. */
export function compareTreeOrder(a, b) {
    return siblingOrder(a, b) || a.length - b.length;
}
/**
 * Negative when `a` is notified `NOTIFICATION_POST_ENTER_TREE` before `b`, zero for one place.
 * `_propagate_ready` notifies a node after all its children (`node.cpp:316-326`), so a descendant
 * comes first.
 */
export function compareReadyOrder(a, b) {
    return siblingOrder(a, b) || b.length - a.length;
}
/** The order of the siblings at the first level where `a` and `b` part, or 0 when one holds the other. */
function siblingOrder(a, b) {
    const shared = Math.min(a.length, b.length);
    for (let level = 0; level < shared; level++) {
        if (a[level] !== b[level])
            return a[level] - b[level];
    }
    return 0;
}
//# sourceMappingURL=TreeOrderContext.js.map